export default {
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.dashboard': '仪表盘',
  // 平台级 (Resource Admin)
  'menu.resource-admin': '平台管理',
  'menu.resource-admin.dashboard': '仪表盘',
  'menu.resource-admin.resource': '资源管理',
  'menu.resource-admin.resource.menus': '菜单管理',
  'menu.resource-admin.resource.roles': '角色定义',
  'menu.resource-admin.resource.resources': '资源管理',
  'menu.resource-admin.resource.resource-types': '资源类型',
  'menu.resource-admin.saas': 'SaaS 管理',
  'menu.resource-admin.saas.tenants': '租户管理',
  'menu.resource-admin.saas.applications': '应用管理',
  'menu.resource-admin.saas.tenant-applications': '租户应用',
  'menu.resource-admin.saas.app-configs': '应用配置',
  'menu.resource-admin.saas.certifications': '实名认证',
  'menu.resource-admin.saas.registration-config': '注册配置',
  'menu.resource-admin.saas.registration-statistics': '注册统计',
  'menu.resource-admin.saas.inactive-tenants': '未登录提醒',
  'menu.resource-admin.message': '消息平台',
  'menu.resource-admin.message.subscriptions': '订阅定义',
  'menu.resource-admin.message.templates': '模板定义',
  'menu.resource-admin.payment': '支付平台',
  'menu.resource-admin.payment.payment-channels': '支付渠道',
  'menu.resource-admin.payment.currencies': '币种管理',
  // 平台级钱包管理（仅币种配置）
  'menu.resource-admin.wallet': '钱包平台',
  'menu.resource-admin.wallet.currencies': '币种配置',
  'menu.resource-admin.authn': '认证管理',
  'menu.resource-admin.authn.oauth2-clients': 'OAuth客户端',
  'menu.resource-admin.authn.oauth2-scopes': 'OAuth Scope',
  'menu.resource-admin.authn.user-agreements': '用户协议',
  'menu.resource-admin.authn.account-cancellations': '账号注销',
  'menu.resource-admin.saas-ext': 'SaaS管理',
  'menu.resource-admin.saas-ext.app-domains': '应用域名',
  'menu.resource-admin.saas-ext.tenant-logs': '租户日志',
  // SaaS Platform
  'menu.saas-platform': 'SaaS平台',
  'menu.saas-platform.workbench': '工作台',
  'menu.saas-platform.workbench.dashboard': '平台概览',
  'menu.saas-platform.workbench.notifications': '系统通知',
  'menu.saas-platform.workbench.my-messages': '我的消息',
  'menu.saas-platform.workbench.support': '帮助与支持',
  'menu.saas-platform.app-center': '应用中心',
  'menu.saas-platform.app-center.resource-market': '资源市场',
  'menu.saas-platform.app-center.my-apps': '我的应用',
  'menu.saas-platform.app-center.tenant-settings': '租户设置',
  'menu.saas-platform.app-center.app-configs': '应用配置管理',
  'menu.saas-platform.management': '平台管理',
  'menu.saas-platform.management.tenant-app': '租户与应用',
  'menu.saas-platform.management.tenant-app.tenants': '租户管理',
  'menu.saas-platform.management.tenant-app.tenant-applications': '租户应用',
  'menu.saas-platform.management.tenant-app.app-configs': '租户应用配置管理',
  'menu.saas-platform.management.platform-management': '平台管理',
  'menu.saas-platform.management.platform-management.users': '平台用户',
  'menu.saas-platform.management.platform-management.roles': '平台角色',
  'menu.saas-platform.management.account-auth': '账号与权限',
  'menu.saas-platform.management.account-auth.users': '用户管理',
  'menu.saas-platform.management.account-auth.user-detail': '用户详情',
  'menu.saas-platform.management.account-auth.roles': '角色管理',
  'menu.saas-platform.management.account-auth.permission-templates': '权限模板',
  'menu.saas-platform.management.account-auth.data-permission-templates':
    '数据权限模板',
  'menu.saas-platform.management.account-auth.user-login-history':
    '用户登录历史',
  'menu.saas-platform.management.account-auth.user-group-types':
    '用户组类型管理',
  'menu.saas-platform.management.account-auth.user-groups': '用户组管理',
  'menu.saas-platform.management.account-auth.role-group-types':
    '角色组类型管理',
  'menu.saas-platform.management.account-auth.role-groups': '角色组管理',
  'menu.saas-platform.apps': '平台应用',
  // CMS 模块
  'menu.cms': '内容管理',
  'menu.cms.sites': '站点管理',
  'menu.cms.channels': '频道管理',
  'menu.cms.articles': '文章管理',
  'menu.cms.link-exchanges': '友链管理',
  'menu.cms.templates': '模板管理',
  // Billing 模块
  'menu.billing': '订阅计费',
  'menu.billing.products': '产品管理',
  'menu.billing.product-plans': '定价方案',
  'menu.billing.orders': '订单管理',
  'menu.billing.subscriptions': '订阅管理',
  'menu.billing.invoices': '发票管理',
  'menu.billing.payment-config': '支付配置',
  'menu.billing.webhook-endpoints': 'Webhook配置',
  'menu.billing.create-unified-test': '下单测试',
  'menu.billing.create-for-user': '代客下单',
  'menu.billing.renewal-for-user': '待客续费',
  'menu.billing.change-plan-for-user': '代客变更订阅',
  'billing.payment-config.merchant-id': '商户ID',
  'billing.payment-config.callback-domain': '回调域名',
  'billing.payment-config.status': '状态',
  'billing.payment-config.status-enabled': '启用',
  'billing.payment-config.status-disabled': '禁用',
  'billing.payment-config.merchant-id-required': '请输入商户ID',
  'billing.payment-config.callback-domain-required': '请输入回调域名',
  'billing.payment-config.update-success': '配置更新成功',
  'billing.payment-config.create-success': '配置创建成功',
  'billing.payment-config.operation-failed': '操作失败',
  // Affiliate 模块
  'menu.affiliate': '推广联盟',
  'menu.affiliate.stats': '数据概览',
  'menu.affiliate.promoters': '推广员管理',
  'menu.affiliate.applications': '入驻审核',
  'menu.affiliate.commissions': '佣金管理',
  'menu.affiliate.links': '推广链接',
  'menu.affiliate.my-profile': '我的推广',
  'menu.affiliate.my-links': '我的链接',
  'menu.affiliate.my-team': '我的团队',
  'menu.affiliate.my-commissions': '我的佣金',
  'menu.affiliate.my-level': '我的等级',
  'menu.affiliate.commission-rules': '佣金规则',
  'menu.affiliate.leader-dashboard': '团长仪表盘',
  'menu.affiliate.team-members': '团队成员',
  'menu.affiliate.bonus-pool': '奖金池',
  'menu.affiliate.webhook-subscriptions': 'Webhook订阅配置',
  // Payment 模块
  'menu.payment': '支付管理',
  'menu.payment.orders': '支付订单',
  'menu.payment.transactions': '交易记录',
  'menu.payment.merchants': '商户管理',
  'menu.payment.merchant-channels': '商户渠道',
  'menu.payment.payment-config': '支付配置',
  'payment.payment-config.domain-id': '域名',
  'payment.payment-config.status': '状态',
  'payment.payment-config.status-enabled': '启用',
  'payment.payment-config.status-disabled': '禁用',
  'payment.payment-config.domain-id-required': '请选择域名',
  'payment.payment-config.update-success': '配置更新成功',
  'payment.payment-config.create-success': '配置创建成功',
  'payment.payment-config.operation-failed': '操作失败',
  // Message 模块
  'menu.message': '消息管理',
  'menu.message.senders': '发送器管理',
  'menu.message.history': '消息历史',
  'menu.message.user-subscriptions': '用户订阅',
  'menu.message.user-channels': '用户渠道',
  'menu.message.blacklists': '黑名单',
  // OSS 模块
  'menu.oss': '存储管理',
  'menu.oss.files': '文件管理',
  'menu.oss.buckets': '存储桶',
  'menu.oss.app-storages': '应用存储',
  // Authn 模块
  'menu.authn': '认证管理',
  'menu.authn.username-blacklists': '用户名黑名单',
  'menu.authn.app-config': '应用配置',
  'menu.authn.agreements': '协议管理',
  'menu.authn.agreements-create': '创建协议',
  'menu.authn.agreements-detail': '协议详情',
  'menu.authn.agreements-edit': '编辑协议',
  'menu.saas-platform.ops': '平台运维',
  'menu.saas-platform.ops.resources': '资源编排',
  'menu.saas-platform.ops.resources.menus': '菜单管理',
  'menu.saas-platform.ops.resources.list': '资源列表',
  'menu.saas-platform.ops.resources.detail': '资源详情',
  'menu.saas-platform.ops.resources.types': '资源类型',
  'menu.saas-platform.ops.global-capabilities': '全局能力',
  'menu.saas-platform.ops.global-capabilities.message-subscriptions':
    '订阅定义',
  'menu.saas-platform.ops.global-capabilities.message-templates': '模板定义',
  'menu.saas-platform.ops.global-capabilities.payment-channels': '支付渠道',
  'menu.saas-platform.ops.global-capabilities.payment-currencies': '支付币种',
  'menu.saas-platform.ops.global-capabilities.wallet-currencies': '钱包币种',
  'menu.saas-platform.ops.security-logs': '安全与日志',

  'menu.saas-platform.ops.global-capabilities.message': '消息服务',
  'menu.saas-platform.ops.global-capabilities.message.message-subscriptions':
    '订阅定义',
  'menu.saas-platform.ops.global-capabilities.message.message-templates':
    '模板定义',
  'menu.saas-platform.ops.global-capabilities.payment': '支付服务',
  'menu.saas-platform.ops.global-capabilities.payment.payment-channels':
    '支付渠道',
  'menu.saas-platform.ops.global-capabilities.payment.payment-currencies':
    '支付币种',
  'menu.saas-platform.ops.global-capabilities.wallet': '钱包服务',
  'menu.saas-platform.ops.global-capabilities.wallet.wallet-currencies':
    '钱包币种',
  'menu.saas-platform.ops.global-capabilities.cms': '内容服务',
  'menu.saas-platform.ops.global-capabilities.cms.cms-templates': '模板管理',
  'menu.saas-platform.ops.global-capabilities.auth': '认证服务',
  'menu.saas-platform.ops.global-capabilities.auth.oauth2-scopes':
    'OAuth2作用域',
  'menu.saas-platform.ops.global-capabilities.oss': '对象存储',
  'menu.saas-platform.ops.global-capabilities.oss.storages': '存储配置',
  'menu.saas-platform.ops.global-capabilities.oss.app-storages': '应用存储',
  'menu.saas-platform.ops.global-capabilities.oss.image-styles': '图片样式',
  'menu.saas-platform.ops.global-capabilities.oss.cdn-config': 'CDN配置',
  'menu.saas-platform.ops.global-capabilities.crontab': '定时任务',
  'menu.saas-platform.ops.global-capabilities.crontab.jobs': '作业管理',
  'menu.saas-platform.ops.global-capabilities.crontab.cron-expressions':
    '表达式预设',
  'menu.saas-platform.ops.global-capabilities.crontab.schedulers': '调度记录',
  'menu.saas-platform.ops.global-capabilities.crontab.workers': 'Worker 列表',
  'menu.saas-platform.ops.security-logs.platform-security-alerts':
    '平台安全告警',
  'menu.saas-platform.ops.security-logs.audit-logs': '审计日志',
  'menu.saas-platform.ops.security-logs.webhook-logs': 'Webhook日志',
  'menu.saas-platform.ops.security-logs.access-logs': '访问日志',
  'menu.saas-platform.task-center': '任务中心',
  'menu.saas-platform.task-center.tasks': '任务管理',
  'menu.saas-platform.task-center.media-convert': '媒体转码',
  'menu.saas-platform.system.billing': '订阅设置',
  'menu.saas-platform.system.billing.payment-config': '订阅支付配置',
  'menu.saas-platform.system.billing.webhook-endpoints': 'Webhook配置',
  'menu.saas-platform.system.affiliate': '推广设置',
  'menu.saas-platform.system.affiliate.webhook-subscriptions':
    'Webhook订阅配置',
  'menu.saas-platform.system.wallet': '钱包设置',
  'menu.saas-platform.system.wallet.config': '钱包配置',
  'menu.saas-platform.system.wallet.security': '安全设置',
  'menu.saas-platform.system.wallet.fee-rules': '手续费规则',
  'menu.saas-platform.system.wallet.risk-rules': '风控规则',
  'menu.saas-platform.system.wallet.limit-config': '限额配置',
  'menu.saas-platform.system.wallet.webhooks': 'Webhook配置',
  'menu.saas-platform.system.wallet.credentials': 'API凭证',
  'menu.saas-platform.system.wallet.blacklists': 'API黑名单',
  'menu.saas-platform.system.app-settings': '应用设置',
  'menu.saas-platform.system.customer-service': '客服联系配置',
  'menu.saas-platform.ops.cms': '内容管理',
  'menu.saas-platform.ops.cms.templates': '模板管理',
  'menu.saas-platform.account': '个人中心',
  'menu.saas-platform.account.profile': '个人资料',
  'menu.saas-platform.account.security': '安全设置',
  'menu.saas-platform.account.login-history': '登录历史',
  'menu.saas-platform.account.preferences': '偏好设置',
  'menu.saas-platform.account.bindings': '账号绑定',
  'menu.saas-platform.account.notifications': '通知设置',
  'menu.saas-platform.account.my-messages': '我的消息',
  // App Basic (应用基础功能)
  'menu.app-basic': '应用基础',
  'menu.app-basic.iam': '身份权限',
  'menu.app-basic.iam.users': '用户管理',
  'menu.app-basic.iam.roles': '角色管理',
  'menu.app-basic.iam.organizations': '组织架构',
  'menu.app-basic.iam.positions': '岗位管理',
  'menu.app-basic.iam.data-permission-templates': '数据权限模板',
  'menu.app-basic.iam.permission-templates': '权限模板',
  'menu.app-basic.iam.security-alerts': '安全告警',
  'menu.app-basic.iam.devices': '设备管理',
  'menu.app-basic.oss': '文件存储',
  'menu.app-basic.oss.files': '文件管理',
  'menu.app-basic.oss.storages': '存储配置',
  'menu.app-basic.oss.app-storages': '应用存储',
  'menu.app-basic.oss.image-styles': '图片样式',
  'menu.app-basic.oss.cdn-config': 'CDN 配置',
  'menu.app-basic.oss.multipart-uploads': '分片上传',
  'menu.app-basic.message': '消息管理',
  'menu.app-basic.message.senders': '发送器',
  'menu.app-basic.message.app-config': '应用配置',
  'menu.app-basic.message.history': '发送记录',
  'menu.app-basic.message.email-records': '邮件记录',
  'menu.app-basic.message.phone-records': '短信记录',
  'menu.app-basic.message.user-channels': '用户渠道',
  'menu.app-basic.message.user-subscriptions': '用户订阅',
  'menu.app-basic.message.blacklists': '黑名单',
  'menu.app-basic.message.dead-letters': '死信队列',
  'menu.app-basic.message.push-devices': '推送设备',
  'menu.app-basic.billing': '计费管理',
  'menu.app-basic.billing.products': '产品管理',
  'menu.app-basic.billing.subscriptions': '订阅管理',
  'menu.app-basic.billing.orders': '订单列表',
  'menu.app-basic.billing.invoices': '发票管理',
  'menu.app-basic.billing.features': '功能特性',
  'menu.app-basic.billing.coupons': '优惠券',
  'menu.app-basic.billing.usage': '用量统计',
  'menu.app-basic.billing.wallets': '钱包管理',
  'menu.app-basic.billing.wallet-ledgers': '钱包流水',
  'menu.app-basic.billing.coupon-codes': '优惠券码',
  'menu.app-basic.billing.coupon-redemptions': '兑换记录',
  'menu.app-basic.payment': '支付管理',
  'menu.app-basic.payment.orders': '订单管理',
  'menu.app-basic.payment.transactions': '交易记录',
  'menu.app-basic.payment.merchant-config': '商户配置',
  'menu.app-basic.payment.merchant': '商户',
  'menu.app-basic.payment.merchant.payment-channels': '商户支付通道',
  'menu.app-basic.payment.channels': '支付渠道',
  'menu.app-basic.payment.currencies': '币种管理',
  'menu.app-basic.payment.reconciliations': '对账管理',
  'menu.app-basic.payment.risk-rules': '风控规则',
  'menu.app-basic.payment.risk-records': '风控记录',
  'menu.app-basic.payment.webhook-logs': 'Webhook日志',
  'menu.app-basic.cms': '内容管理',
  'menu.app-basic.cms.sites': '站点管理',
  'menu.app-basic.cms.channels': '频道管理',
  'menu.app-basic.cms.articles': '文章管理',
  'menu.app-basic.cms.albums': '专辑管理',
  'menu.app-basic.cms.carousel': '轮播管理',
  'menu.app-basic.cms.sensitive-words': '敏感词管理',
  'menu.app-basic.cms.guestbooks': '留言管理',
  'menu.app-basic.cms.content-reviews': '内容审核',
  'menu.app-basic.cms.templates': '模板管理',
  'menu.app-basic.cms.link-exchanges': '友情链接',
  // 微信管理
  'menu.app-basic.wechat': '微信管理',
  'menu.app-basic.wechat.menus': '菜单管理',
  'menu.app-basic.wechat.materials': '素材管理',
  'menu.app-basic.wechat.messages': '消息记录',
  // 媒体转码
  'menu.app-basic.media-convert': '媒体转码',
  'menu.app-basic.media-convert.tasks': '转码任务',
  // 租户级 SaaS 管理
  'menu.app-basic.saas': 'SaaS 配置',
  'menu.app-basic.saas.settings': '租户设置',
  'menu.app-basic.saas.app-configs': '应用配置',
  'menu.app-basic.saas.audit-logs': '审计日志',
  // 租户级钱包管理
  'menu.app-basic.wallet': '钱包管理',
  'menu.app-basic.wallet.wallets': '钱包列表',
  'menu.app-basic.wallet.accounts': '子账户管理',
  'menu.app-basic.wallet.transactions': '交易记录',
  'menu.app-basic.wallet.account-logs': '流水记录',
  'menu.app-basic.wallet.operations': '钱包操作',
  'menu.app-basic.wallet.withdraw-orders': '提现订单',
  'menu.app-basic.wallet.statistics': '统计报表',
  'menu.app-basic.wallet.external-accounts': '外部账户',
  'menu.app-basic.wallet.webhooks': 'Webhook配置',
  'menu.app-basic.wallet.security': '安全设置',
  'menu.app-basic.wallet.credentials': 'API凭证',
  'menu.app-basic.wallet.reconciliation': '对账管理',
  'menu.app-basic.wallet.fee-rules': '手续费规则',
  'menu.app-basic.wallet.risk-rules': '风控规则',
  'menu.app-basic.wallet.limit-config': '限额配置',
  'menu.app-basic.wallet.batch-operations': '批量操作',
  'menu.app-basic.wallet.points-expiry': '积分过期',
  'menu.app-basic.wallet.reversals': '交易撤销',
  'menu.app-basic.wallet.config': '钱包配置',
  'menu.app-basic.wallet.blacklists': 'API黑名单',
  'menu.app-basic.wallet.access-logs': '访问日志',
  'menu.app-basic.wallet.recharge-applications': '充值申请',
  // 钱包管理（路由级）
  'menu.wallet': '钱包管理',
  'menu.wallet.wallets': '钱包列表',
  'menu.wallet.accounts': '子账户管理',
  'menu.wallet.transactions': '交易记录',
  'menu.wallet.account-logs': '流水记录',
  'menu.wallet.operations': '钱包操作',
  'menu.wallet.withdraw-orders': '提现订单',
  'menu.wallet.statistics': '统计报表',
  'menu.wallet.external-accounts': '外部账户',
  'menu.wallet.webhooks': 'Webhook配置',
  'menu.wallet.security': '安全设置',
  'menu.wallet.credentials': 'API凭证',
  'menu.wallet.reconciliation': '对账管理',
  'menu.wallet.fee-rules': '手续费规则',
  'menu.wallet.risk-rules': '风控规则',
  'menu.wallet.limit-config': '限额配置',
  'menu.wallet.batch-operations': '批量操作',
  'menu.wallet.points-expiry': '积分过期',
  'menu.wallet.reversals': '交易撤销',
  'menu.wallet.config': '钱包配置',
  'menu.wallet.blacklists': 'API黑名单',
  'menu.wallet.access-logs': '访问日志',
  'menu.wallet.recharge-applications': '充值申请',
  'menu.app-basic.authn': '认证管理',
  'menu.app-basic.authn.agreements': '协议管理',
  'menu.app-basic.authn.agreements-create': '创建协议',
  'menu.app-basic.authn.agreements-detail': '协议详情',
  'menu.app-basic.authn.agreements-edit': '编辑协议',
  // 用户端消息
  'menu.my-messages': '我的消息',
  // 用户端钱包
  'menu.my-wallet': '我的钱包',
  // 消息运营
  'menu.message-operating': '消息运营',
  'menu.message-operating.campaigns': '营销活动',
  'menu.message-operating.segments': '用户分群',
  'menu.message-operating.scheduled': '定时消息',
  'menu.message-operating.ab-tests': 'A/B 测试',
  'menu.message-operating.stats': '发送统计',
  // 异常页
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  // 账户
  'menu.account': '个人中心',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.logout': '退出登录',
  'menu.account.profile': '个人资料',
  'menu.account.security': '安全设置',
  'menu.account.certification': '企业认证',
  'menu.account.notifications': '消息通知',
  'menu.account.login-history': '登录历史',
  'menu.account.preferences': '偏好设置',
  'menu.account.bindings': '账号绑定',
  'menu.account.recharge-application': '充值申请',
  'menu.account.my-wallet': '我的钱包',
  // 动态菜单（后端返回的菜单名称，locale key 格式为 "menu.{后端name}"）
  // ProLayout 会自动将 name 转为 "menu.{name}" 作为 formatMessage 的 id
  // 如果找不到对应 key，则 fallback 显示后端返回的原始名称
  'menu.系统': '系统',
  'menu.应用': '应用',
  'menu.用户管理': '用户管理',
  'menu.用户列表': '用户列表',
  'menu.角色管理': '角色管理',
  'menu.权限管理': '权限管理',
  'menu.报表': '报表',
  'menu.审计日志': '审计日志',
  'menu.设置': '设置',
  'menu.常规设置': '常规设置',
  'menu.系统设置': '系统设置',
  'menu.菜单管理': '菜单管理',
  'menu.资源管理': '资源管理',
  'menu.租户管理': '租户管理',
  'menu.应用管理': '应用管理',
  'menu.资源类型': '资源类型',
  // CDN 运维系统
  'menu.cdn-ops': 'CDN 运维',
  'menu.cdn-ops.dashboard': 'Dashboard',
  'menu.cdn-ops.sites': '站点管理',
  'menu.cdn-ops.site-detail': '站点详情',
  'menu.cdn-ops.nodes': '节点管理',
  'menu.cdn-ops.nodes.node-detail': '节点详情',
  'menu.cdn-ops.nodes.node-default-config': '默认配置',
  'menu.cdn-ops.node-ips': '节点 IP 管理',
  'menu.cdn-ops.lines': '线路管理',
  'menu.cdn-ops.lines.line-detail': '线路详情',
  'menu.cdn-ops.lines.line-detail-feature': '线路详情',
  'menu.cdn-ops.dns': 'DNS 管理',
  'menu.cdn-ops.monitor': '监控统计',
  'menu.cdn-ops.bigscreen': '全域大屏',
  'menu.cdn-oper.workbench-bigscreen': '全域大屏',
  // CDN 运维 - Tab 描述
  'cdn.node.tab.desc.basic':
    '查看节点基本信息，包括设备码、IP地址、区域、状态等。',
  'cdn.node.tab.desc.config':
    '管理节点的配置参数，支持继承全局默认配置或自定义节点专属配置。',
  'cdn.node.tab.desc.stats':
    '查看节点的流量统计信息，包括请求量、带宽、缓存命中率等。',
  // CDN 运维 - 节点侧边栏
  'cdn.node.sideMenu.group.basic': '节点信息',
  'cdn.node.sideMenu.backToList': '返回节点列表',
  'cdn.node.tab.basic': '基本信息',
  'cdn.node.tab.config': '配置管理',
  'cdn.node.tab.stats': '流量统计',
  'menu.cdn-ops.nodes.node-detail-feature': '节点详情',
  // CDN 运维 - 通用操作
  'cdn.common.back': '返回',
  'cdn.common.refresh': '刷新',
  // CDN 运营系统
  'menu.cdn-oper': 'CDN 运营',
  'menu.cdn-oper.sites': '站点管理',
  'menu.cdn-oper.site-detail': '站点详情',
  // ===== CDN 运营系统 =====
  // 工作台
  'menu.cdn-oper.workbench': '工作台',
  'menu.cdn-oper.workbench.dashboard': 'CDN 概览',
  'menu.cdn-oper.workbench.admin-dashboard': '管理员概览',
  'menu.cdn-oper.workbench.notifications': '系统通知',
  'menu.cdn-oper.workbench.messages': '我的消息',
  'menu.cdn-oper.workbench.support': '帮助与支持',
  // 官网管理
  'menu.cdn-oper.cms': '官网管理',
  'menu.cdn-oper.cms.sites': '站点管理',
  'menu.cdn-oper.cms.channels': '栏目管理',
  'menu.cdn-oper.cms.articles': '文章管理',
  'menu.cdn-oper.cms.albums': '相册管理',
  'menu.cdn-oper.cms.carousel': '轮播管理',
  'menu.cdn-oper.cms.carousel-groups': '轮播分组',
  'menu.cdn-oper.cms.link-exchanges': '友情链接',
  'menu.cdn-oper.cms.guestbooks': '留言管理',
  'menu.cdn-oper.cms.content-reviews': '内容审核',
  'menu.cdn-oper.cms.sensitive-words': '敏感词管理',
  // 账号与权限
  'menu.cdn-oper.auth': '账号与权限',
  'menu.cdn-oper.auth.users': '用户管理',
  'menu.cdn-oper.auth.roles': '角色管理',
  'menu.cdn-oper.auth.user-login-history': '登录历史',
  // 订阅计费
  'menu.cdn-oper.billing': '订阅计费',
  'menu.cdn-oper.pricing': '套餐定价',
  'menu.cdn-oper.billing.products': '产品管理',
  'menu.cdn-oper.billing.features': '特性管理',
  'menu.cdn-oper.billing.subscriptions': '订阅管理',
  'menu.cdn-oper.billing.orders': '订单管理',
  'menu.cdn-oper.billing.usage': '用量管理',
  'menu.cdn-oper.billing.coupons': '优惠券管理',
  'menu.cdn-oper.billing.invoices': '发票管理',
  'menu.cdn-oper.billing.payment-config': '支付配置',
  'menu.cdn-oper.billing.my-subscriptions': '我的订阅',
  'menu.cdn-oper.billing.my-orders': '我的订单',
  'menu.cdn-oper.billing.my-invoices': '我的发票',
  'menu.cdn-oper.billing.my-usage': '我的用量',
  'menu.cdn-oper.billing.create-for-user': '代客下单',
  'menu.cdn-oper.billing.renewal-for-user': '待客续费',
  // 支付与资金
  'menu.cdn-oper.payment': '支付与资金',
  'menu.cdn-oper.payment.trades': '交易记录',
  'menu.cdn-oper.payment.merchants': '商户配置',
  'menu.cdn-oper.payment.merchant-channels': '商户支付通道',
  // 消息管理
  'menu.cdn-oper.message': '消息管理',
  'menu.cdn-oper.message.senders': '发送器管理',
  'menu.cdn-oper.message.history': '消息历史',
  'menu.cdn-oper.message.user-subscriptions': '用户订阅',
  'menu.cdn-oper.message.user-channels': '用户渠道',
  'menu.cdn-oper.message.blacklists': '黑名单管理',
  // 任务中心（新增）
  'menu.cdn-oper.task-center': '任务中心',
  'menu.cdn-oper.task-center.tasks': '任务列表',
  'menu.cdn-oper.task-center.media-convert': '媒体转码',
  // 认证配置（新增）
  'menu.cdn-oper.authn': '认证配置',
  'menu.cdn-oper.authn.username-blacklists': '用户名黑名单',
  'menu.cdn-oper.authn.app-config': '应用配置',
  'menu.cdn-oper.authn.agreements': '协议管理',
  // 系统设置
  'menu.cdn-oper.system': '系统设置',
  'menu.cdn-oper.system.app-settings': '应用设置',
  'menu.cdn-oper.system.customer-service': '客服联系配置',
  'menu.cdn-oper.system.files': '文件管理',
  'menu.cdn-oper.system.storages': '存储配置',
  'menu.cdn-oper.system.app-storages': '应用存储',
  'menu.cdn-oper.system.billing': '订阅设置',
  'menu.cdn-oper.system.billing.payment-config': '订阅支付配置',
  'menu.cdn-oper.system.billing.webhook-endpoints': 'Webhook配置',
  'menu.cdn-oper.system.affiliate': '推广设置',
  'menu.cdn-oper.system.affiliate.webhook-subscriptions': 'Webhook订阅配置',
  'menu.cdn-oper.system.wallet': '钱包设置',
  'menu.cdn-oper.system.wallet.config': '钱包配置',
  'menu.cdn-oper.system.wallet.security': '安全设置',
  'menu.cdn-oper.system.wallet.fee-rules': '手续费规则',
  'menu.cdn-oper.system.wallet.risk-rules': '风控规则',
  'menu.cdn-oper.system.wallet.limit-config': '限额配置',
  'menu.cdn-oper.system.wallet.webhooks': 'Webhook配置',
  'menu.cdn-oper.system.wallet.credentials': 'API凭证',
  'menu.cdn-oper.system.wallet.blacklists': 'API黑名单',
  // 个人中心
  'menu.cdn-oper.account': '个人中心',
  'menu.cdn-oper.account.profile': '个人资料',
  'menu.cdn-oper.account.security': '安全设置',
  'menu.cdn-oper.account.login-history': '登录历史',
  'menu.cdn-oper.account.preferences': '偏好设置',
  'menu.cdn-oper.account.bindings': '账号绑定',
  'menu.cdn-oper.account.recharge-application': '充值申请',
  // CDN 运营 - 隐藏页面
  'menu.cdn-oper.site-create': '创建站点',
  'menu.cdn-oper.site-detail-feature': '站点功能详情',
  'menu.cdn-oper.cms.article-create': '创建文章',
  'menu.cdn-oper.cms.article-edit': '编辑文章',
  'menu.cdn-oper.cms.article-preview': '预览文章',
  'menu.cdn-oper.cms.album-create': '创建相册',
  'menu.cdn-oper.cms.album-edit': '编辑相册',
  'menu.cdn-oper.cms.album-preview': '预览相册',
  'menu.cdn-oper.authn.agreement-create': '创建协议',
  'menu.cdn-oper.authn.agreement-detail': '协议详情',
  'menu.cdn-oper.authn.agreement-edit': '编辑协议',
  // Cloak 防护规则
  'menu.cloak': '防护规则',
  'menu.cloak.sites': '站点管理',
  'menu.cloak.sites.create': '创建站点',
  'menu.cloak.sites.detail': '站点详情',
  'menu.cloak.rule-templates': '规则模板',
  'menu.cloak.visit-limit-templates': '访问限制模板',
  'menu.cloak.global-ip-acls': '全局黑白名单',
  'menu.cloak.dashboard': '概览仪表盘',
  'menu.cloak.visit-logs': '访问日志',
  'menu.cloak.visit-stats': '访问统计',

  'menu.cloak.domains': '域名管理',
  'menu.cloak.system-cloak-settings': 'Cloak 设置',
  'menu.cloak.system-cloak-settings-domain-config': '域名配置',
  // Cloak 账号与权限
  'menu.cloak.auth': '账号与权限',
  'menu.cloak.auth.users': '用户管理',
  'menu.cloak.auth.roles': '角色管理',
  'menu.cloak.auth.user-group-types': '用户组类型',
  'menu.cloak.auth.user-groups': '用户组管理',
  'menu.cloak.auth.role-group-types': '角色组类型',
  'menu.cloak.auth.role-groups': '角色组管理',
  // Cloak 系统设置
  'menu.cloak.system-app-settings': '应用设置',
  'menu.cloak.system-oss-files': '文件管理',
  'menu.cloak.system-oss-storages': '存储配置',
  'menu.cloak.system-oss-app-storages': '应用存储',
  'menu.cloak.system-oss-config': 'OSS配置',
  'menu.cloak.system-authn-username-blacklists': '用户名黑名单',
  'menu.cloak.system-authn-app-config': '认证配置',
  // Cloak 个人中心
  'menu.cloak.account-profile': '个人资料',
  'menu.cloak.account-security': '安全设置',
  'menu.cloak.account-login-history': '登录历史',
  'menu.cloak.account-preferences': '偏好设置',
  'menu.cloak.account-bindings': '账号绑定',
  // Ticket CDN-Oper 工单中心
  'menu.cdn-oper.ticket': '工单中心',
  'menu.cdn-oper.ticket.my-tickets': '我的工单',
  'menu.cdn-oper.ticket.my-tickets-list': '工单列表',
  'menu.cdn-oper.ticket.my-tickets-create': '创建工单',
  'menu.cdn-oper.ticket.my-tickets-detail': '工单详情',
  'menu.cdn-oper.ticket.my-tickets-edit': '编辑工单',
  'menu.cdn-oper.ticket.admin': '工单管理',
  'menu.cdn-oper.ticket.admin-tickets': '工单管理',
  'menu.cdn-oper.ticket.admin-ticket-detail': '工单详情',
  'menu.cdn-oper.ticket.admin-ticket-edit': '编辑工单',
  'menu.cdn-oper.ticket.statistics': '统计仪表盘',
  'menu.cdn-oper.ticket.basic-settings': '基础设置',
  'menu.cdn-oper.ticket.settings.org-category': '组织分类',
  'menu.cdn-oper.ticket.settings.categories': '工单分类',
  'menu.cdn-oper.ticket.settings.tags': '标签管理',
  'menu.cdn-oper.ticket.settings.team-fields': '团队字段',
  'menu.cdn-oper.ticket.settings.teams': '客服团队',
  'menu.cdn-oper.ticket.settings.custom-fields': '自定义字段',
  'menu.cdn-oper.ticket.settings.form-templates': '表单模板',
  'menu.cdn-oper.ticket.settings.ticket-forms': '工单表单',
  'menu.cdn-oper.ticket.settings.ticket-templates': '工单模板',
  'menu.cdn-oper.ticket.settings.business-config': '业务配置',
  'menu.cdn-oper.ticket.settings.canned-responses': '快捷回复',
  'menu.cdn-oper.ticket.settings.business-hours': '业务时间',
  'menu.cdn-oper.ticket.strategy': '服务策略',
  'menu.cdn-oper.ticket.strategy.slas': 'SLA 策略',
  'menu.cdn-oper.ticket.strategy.workflows': '工作流',
  'menu.cdn-oper.ticket.strategy.automation-rules': '自动化规则',
  'menu.cdn-oper.ticket.strategy.escalation-rules': '升级规则',
  'menu.cdn-oper.ticket.logs': '日志审计',
  'menu.cdn-oper.ticket.logs.notification-rules': '通知规则',
  'menu.cdn-oper.ticket.logs.spam-rules': '垃圾规则',
  'menu.cdn-oper.ticket.logs.satisfactions': '满意度',
  'menu.cdn-oper.ticket.logs.notification-logs': '通知日志',
  'menu.cdn-oper.ticket.logs.escalation-logs': '升级日志',
  'menu.cdn-oper.ticket.logs.automation-logs': '自动化日志',
  // Ticket 工单管理
  'menu.ticket': '工单管理',
  'menu.ticket.my-tickets': '我的工单',
  'menu.ticket.tenant-tickets': '工单管理',
  'menu.ticket.slas': 'SLA 策略',
  'menu.ticket.workflows': '工作流',
  'menu.ticket.automation-rules': '自动化规则',
  'menu.ticket.escalation-rules': '升级规则',
  'menu.ticket.custom-fields': '自定义字段',
  'menu.ticket.teams': '客服团队',
  'menu.ticket.categories': '工单分类',
  'menu.ticket.tags': '标签管理',
  'menu.ticket.canned-responses': '快捷回复',
  'menu.ticket.notification-rules': '通知规则',
  'menu.ticket.spam-rules': '垃圾规则',
  'menu.ticket.ticket-forms': '工单表单',
  'menu.ticket.ticket-templates': '工单模板',
  'menu.ticket.business-hours': '业务时间',
  'menu.ticket.statistics': '统计仪表盘',
  'menu.ticket.satisfactions': '满意度',
  'menu.ticket.notification-logs': '通知日志',
  'menu.ticket.escalation-logs': '升级日志',
  'menu.ticket.automation-logs': '自动化日志',
};
